<section class="password-container text-center grid">
  <div class="p-offset-0 col-12 md:col-6 md:col-offset-3">
    <p-card class="compact-panel">
      <app-page-title
        [icon]="'key'"
        [pageTitle]="'common.password.change-password' | translate"
      ></app-page-title>

      @if (!canChangePassword) {
        <div class="p_field mb-4">
          @if (errorMessage) {
            <p-message severity="error">
              {{ errorMessage }}
            </p-message>
          }
        </div>
      }

      @if (passwordSuccessfullyChanged) {
        <p-message severity="success">
          {{ 'common.password.password-changed-successfully' | translate }}
        </p-message>
        <div class="field">
          <button
            pButtonLabel
            [type]="'buttom'"
            [routerLink]="['/']"
            class="p-button p-button-primary"
          >
            {{ 'common.home' | translate }}
          </button>
        </div>
      }

      @if (
        !passwordSuccessfullyChanged && canChangePassword && correctPassword
      ) {
        <form
          autocomplete="off"
          [formGroup]="passwordForm"
          (ngSubmit)="submitNewPassword()"
        >
          <!-- Hidden, off-screen dummy fields to reduce aggressive browser autofill (best-effort) -->
          <input
            type="text"
            name="fake-username"
            autocomplete="username"
            style="position: absolute; left: -9999px; top: 0"
            tabindex="-1"
          />
          <input
            type="password"
            name="fake-password"
            autocomplete="new-password"
            style="position: absolute; left: -9999px; top: 0"
            tabindex="-1"
          />
          <div class="p_field mb-4">
            @if (errorMessage) {
              <p-message severity="error">
                {{ errorMessage }}
              </p-message>
            }
          </div>
          <div class="field p-fluid">
            <div class="p-inputgroup">
              <!-- main new password field; request new-password autocomplete -->
              <p-password
                formControlName="newPassword"
                placeholder="{{ 'common.password.new-password' | translate }}"
                id="newPassword"
                autocomplete="new-password"
              ></p-password>
              <!-- copy icon removed: copying is handled from staff page for admin workflows -->
            </div>
          </div>
          <div class="field p-fluid">
            <p-password
              formControlName="newPasswordAgain"
              placeholder="{{
                'common.password.new-password-again' | translate
              }}"
              id="newPasswordAgain"
              autocomplete="new-password"
              [feedback]="false"
            ></p-password>
          </div>
          <div class="field">
            <button pButton [type]="'submit'">
              {{ 'common.button.submit' | translate }}
            </button>
          </div>
        </form>
      }
      @if (
        !passwordSuccessfullyChanged && canChangePassword && !correctPassword
      ) {
        <form
          autocomplete="off"
          [formGroup]="passwordForm"
          (ngSubmit)="submitOldPassword()"
        >
          @if (errorMessage) {
            <div class="p_field mb-4">
              <p-message severity="error">
                {{ errorMessage }}
              </p-message>
            </div>
          }

          <div class="field p-fluid">
            <!-- encourage browsers to use the current-password autocomplete for the old password -->
            <p-password
              formControlName="oldPassword"
              placeholder="{{
                'common.password.insert-current-password' | translate
              }}"
              id="oldPassword"
              autocomplete="current-password"
              [feedback]="false"
            ></p-password>
          </div>
          <div class="field">
            <button pButton [type]="'submit'">
              {{ 'common.button.submit' | translate }}
            </button>
          </div>
        </form>
      }
    </p-card>
  </div>
</section>
